import { useMutation, useQuery } from '@apollo/client';
import { message } from 'antd';
import {
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Document,
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1FieldsFragment,
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateDocument,
  CasesCredentialVerificationChangeStatusContainerFileInfoFieldsFragment,
  CasesCredentialVerificationChangeStatusContainerStaffUserCurrentDocument,
  CasesCredentialVerificationChangeStatusContainerStaffUserFieldsFragment,
  CredentialVerificationCaseV1UpdateInput
} from '../../../../../../generated';
import { useOid } from '../../../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../../../shared/utils/queryOptions';
import { ChangeStatus } from './change-status';

interface ChangeStatusContainerProps {
  caseId: string;
}

export const ChangeStatusContainer: React.FC<ChangeStatusContainerProps> = (props) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const {
    data: caseStatusData,
    loading: caseStatusLoading,
    error: caseStatusError
  } = useQuery(CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Document, {
    variables: {
      credentialVerificationCaseV1Id: props.caseId,
      fileName: 'verification-component-packet.pdf'
    }
  });

  const {
    data: staffUserData,
    loading: staffUserLoading,
    error: staffUserError
  } = useQuery(CasesCredentialVerificationChangeStatusContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  const [caseDataChangeStatus] = useMutation(CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateDocument);

  const handleChangeStatus = async (values: CredentialVerificationCaseV1UpdateInput) => {
    try {
      const result = await caseDataChangeStatus({
        variables: {
          input: values
        }
      });
      if (!result.data?.credentialVerificationCaseV1Update?.status.success) {
        message.error(`Error changing case status : ${result.data?.credentialVerificationCaseV1Update?.status.errorMessage}`);
      } else {
        message.success('Status changed successfully');
      }
    } catch (error) {
      message.error(`Error changing case status : ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={caseStatusLoading || staffUserLoading}
      error={caseStatusError || staffUserError}
      hasData={caseStatusData?.credentialVerificationCaseV1 && staffUserData?.staffUserCurrent}
      hasDataComponent={
        <ChangeStatus
          data={{
            caseData: caseStatusData?.credentialVerificationCaseV1 as CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1FieldsFragment,
            userData: staffUserData?.staffUserCurrent as CasesCredentialVerificationChangeStatusContainerStaffUserFieldsFragment,
            fileData: caseStatusData?.credentialVerificationCaseV1?.fileByFileName as CasesCredentialVerificationChangeStatusContainerFileInfoFieldsFragment
          }}
          onChangeStatus={handleChangeStatus}
        />
      }
    />
  );
};
